export default __webpack_public_path__ + "static/media/Sprite_Icon_Stat_01.e759b9d9.png";